import { render } from "./EditToken.vue?vue&type=template&id=4c47ba36"
import script from "./EditToken.vue?vue&type=script&lang=js"
export * from "./EditToken.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__